import cart from '@ppcp/cart';
import order from '@ppcp/order';
import {getSetting, getPage} from '@ppcp/utils';
import {CheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import ApplePayGateway from '../gateways/ApplePayGateway';
import {registerPaymentMethod} from '@ppcp/payment-methods';

const settings = getSetting('ppcp_applepay_data');

const gateway = new ApplePayGateway({
    id: 'ppcp_applepay',
    cart,
    settings
});

const controller = new CheckoutController({
    id: 'ppcp_applepay',
    cart,
    order,
    context: new Context(getPage()),
    gateway,
    settings
});

registerPaymentMethod(gateway);

controller.initialize();